import React from 'react';
import { DDL } from 'types/general.types';
import { getAvatarImage } from 'app/utils/utils';
import { Flex, Text } from '@chakra-ui/react';
import { SearchableProfile } from 'types/notification.types';
import { formatCountryLocation } from 'app/utils/helpers';
import { ChakraAvatar } from '../ChakraAvatar';

interface ChakraProfileSearchOptionProps {
  option: SearchableProfile;
  countriesDDL: DDL;
  currentProfileGuid?: string;
  children?: React.ReactNode;
}

export const ChakraProfileSearchOption: React.FC<ChakraProfileSearchOptionProps> = ({
  option,
  countriesDDL,
  currentProfileGuid,
  children,
}) => (
  <Flex maxWidth="100%" alignItems="center" role="option">
    <ChakraAvatar
      src={getAvatarImage(option.profileImages)}
      initials={option.initials}
      colors={option.avatarColors}
      size="sm"
      mr={4}
    />
    <Flex flexDirection="column" textOverflow="ellipsis" overflow="hidden">
      <Flex alignItems="end" data-testid="search-option">
        {children}
        {currentProfileGuid === option.guid && (
          <Text
            fontSize="sm"
            color="textSubdued"
            data-testid="self-indicator"
            ml={2}
          >
            (you)
          </Text>
        )}
      </Flex>

      <Text fontSize="xxs" width="100%" data-testid="address">
        {formatCountryLocation(countriesDDL, option?.address || {})}
      </Text>
    </Flex>
  </Flex>
);
